import {
  createContext,
  useCallback,
  useContext,
  useEffect,
  useState,
} from 'react'
import { defineAuth } from '../services/axiosInstance'
import { RequestService } from '../services/RequestService'

const ConfigContext = createContext({})

function getCookies() {
  const cookies = document.cookie.split('; ')
  const cookieObj = {}
  cookies.forEach(cookie => {
    const [name, value] = cookie.split('=')
    cookieObj[name] = decodeURIComponent(value)
  })
  return cookieObj
}

export const ConfigProvider = ({ children }) => {
  const [data, setData] = useState(null)

  const fetchData = useCallback(async token => {
    try {
      const { _auth } = getCookies()
      if (!_auth) return

      defineAuth({ token: _auth })

      const { data } = await RequestService.getContextInfo()
      setData(data)
    } catch (e) {
      console.log('useContextInfo', e)
    }
  }, [])

  useEffect(() => {
    fetchData()
  }, [])

  return (
    <ConfigContext.Provider
      value={{
        fetchData,
        accountName: data?.account_name,
        plan: data?.plan,
        role: data?.role_access,
        pvtDuration: data?.pvt_config?.duration,
        locale: data?.locale
      }}
    >
      {children}
    </ConfigContext.Provider>
  )
}

export const useConfigContextInfo = () => {
  return useContext(ConfigContext)
}
